var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-menu.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 6.5H20V8.5H4V6.5ZM4 11.5H20V13.5H4V11.5ZM4 16.5H20V18.5H4V16.5Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMenu);
export default __webpack_public_path__ + "static/media/bx-menu.12565de285b010c885a71504c9b911b6.svg";
export { ForwardRef as ReactComponent };